import { Box, CircularProgress } from "@mui/material";
import { loadingContainer, loadingSubContainer } from "./styles";
import { colors } from "../../theme/colors";

const LoadingView = () => {
  return (
    <Box>
      <Box sx={(theme) => loadingContainer(theme)} />
      <Box sx={(theme) => loadingSubContainer(theme)}>
        <CircularProgress
          size={50}
          sx={{
            color: colors.main,
          }}
        />
      </Box>
    </Box>
  );
};

export default LoadingView;
